module.exports = __webpack_public_path__ + "img/emoji_direita.6680ec1e.png";